import { listResponse } from '../../utils/listResponse';
import { runLogSchema } from './../models/runLog.schema';

export const runLogs = (runUuid: string) => {
  return {
    endpoint: `/hooks/runs/${runUuid}/logs`,
    method: 'GET',
    responseSchema: listResponse(runLogSchema),
  } as const;
};
